<igx-card class="igx-card--outlined2" style="height: 100%; width: 100%">
  <igx-card-content class="igx-card-content2">
    <igx-spreadsheet #spreadsheet height="100%" width="100%" isFormulaBarVisible="false" (activeWorksheetChanged)="activeWorksheetChanged()"
                     (editModeEntered)="editModeEntered($event)" (editModeExited)="editModeExited($event)" class="neo-spreadsheet-surface" />
  </igx-card-content>

  @if (verCargarArchivo || verBotones) {
    <igx-card-actions>
      <igx-navbar id="navBarFooter">
        <igx-navbar-action>
          <input id="file" #inputFile type="file" accept=".xls, .xlsx" (change)="openFile($event)" [hidden]="true"/>
          <igx-input-group style="width: 710px;" [hidden]="!verCargarArchivo">
            <igx-prefix>
              <button title="{{ 'MENSAJES.GRALS.INPUT_BOTON_TEXTO' | translate }}" igxButton="contained" igxRipple (buttonClick)="inputFile.click()">
                <igx-icon>file_upload</igx-icon>
                {{ 'MENSAJES.GRALS.INPUT_BOTON_TEXTO' | translate }}
              </button>
            </igx-prefix>
            <label igxLabel>{{ 'MENSAJES.GRALS.DOCUMENTOS' | translate }}:</label>
            <input #inputDocumento id="doc" igxInput [title]="nombreDocumento" [value]="nombreDocumento" type="text" placeholder="{{ 'MENSAJES.GRALS.NINGUN_ARCHIVO_ELEGIDO' | translate }}" [readonly]="true"/>
          </igx-input-group>
        </igx-navbar-action>
        @if (verBotones) {
          <button title="{{ 'BOTONES.GUARDAR' | translate}}" igxButton="contained" (buttonClick)="guardarInfo()">{{ 'BOTONES.GUARDAR' | translate}}</button>
          <button title="{{ 'BOTONES.CANCELAR' | translate}}" igxButton="flat" (buttonClick)="close()">{{ 'BOTONES.CANCELAR' | translate}}</button>
        }
      </igx-navbar>
    </igx-card-actions>
  }
</igx-card>
